import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PatientApi } from '@core/apis/patient/patient.api';
import { PatientDTO } from '@core/apis/patient/patient.dto';
import { PatientAboutComponent } from '@core/components/patient/patient-about/patient-about.component';
import { IUserStore } from '@core/interfaces/interface';
import { UserStore } from '@core/stores/user.store';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FamilyComponent } from './family/family.component';

@Component({
  selector: 'app-patient-main',
  imports: [PatientAboutComponent, RouterModule, TranslocoModule, CommonModule, FormsModule, FamilyComponent],
  templateUrl: './patient-main.component.html',
  styleUrl: './patient-main.component.scss',
})
@UntilDestroy()
export class PatientMainComponent {
  @Input() editLink!: string;
  public patient: PatientDTO | null = null;
  private user: IUserStore | null = null;
  constructor(
    private readonly patientApi: PatientApi,
    private readonly userStore: UserStore,
  ) {}

  ngOnInit(): void {
    this.getPatient();
  }

  getPatient() {
    this.user = this.userStore.get();
    if (!this.user) return;

    this.patientApi
      .getById(this.user.id)
      .pipe(untilDestroyed(this))
      .subscribe((patient) => {
        this.patient = patient;
      });
  }
}
